// src/modules/restaurant/pages/orders/components/OrderDetails/OrderActions.tsx
import React from "react";
import { OrderList } from "../../types/orderTypes";

interface Props {
  onPrint: (order: OrderList) => void;
  onPay: () => void;
  getBgClass: () => string;
  isCompleted: boolean;
  total: string | number;
  selectedOrder: OrderList; // Add this prop
}

const OrderActions: React.FC<Props> = ({ onPrint, onPay, getBgClass, isCompleted, total, selectedOrder }) => (
  <div className="border-t px-4 py-2 flex-shrink-0">
    <div className="flex flex-col sm:flex-row gap-3 justify-between">
      <button onClick={() => onPrint(selectedOrder)}
        className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
      >
        <i className="fas fa-print"></i> Print Receipt
      </button>

      {!isCompleted && (
        <button onClick={onPay}
          className={`inline-flex items-center justify-center gap-2 px-8 py-3 ${getBgClass()} hover:opacity-90 text-white font-bold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105`}
        >
          <i className="fas fa-rupee-sign"></i> Pay Now - {total}
        </button>
      )}
    </div>
  </div>
);

export default OrderActions;